import { render, staticRenderFns } from "./weflDetail.vue?vue&type=template&id=8b9a4eb0&scoped=true"
import script from "./weflDetail.vue?vue&type=script&lang=js"
export * from "./weflDetail.vue?vue&type=script&lang=js"
import style0 from "./weflDetail.vue?vue&type=style&index=0&id=8b9a4eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9a4eb0",
  null
  
)

export default component.exports